import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import React from "react";

const SentimentDoughnut = ({ positive = 0, neutral = 0, negative = 0 }) => {
  ChartJS.register(ArcElement, Tooltip, Legend);
  const data = {
    labels: [`Positive (${positive})`, `Neutral (${neutral})`, `Negative (${negative})`],
    datasets: [
      {
        label: "Sentences",
        data: [positive, neutral, negative],
        backgroundColor: ["#21A161", "lightgray", "#F53D3D"],
        hoverOffset: 6,
      },
    ],
  };

  return (
    <Doughnut
      data={data}
      options={{
        aspectRatio: 1.6,
        plugins: {
          tooltip: {
            boxPadding: 5,
            callbacks: {
              label: ({ formattedValue }) => `Sentences: ${formattedValue}`,
            },
          },
          legend: {
            display: true,
            position: "right",
            labels: {
              padding: 20,
              font: {
                size: 15,
              },
            },
            onClick: () => {},
          },
        },
      }}
    />
  );
};

export default SentimentDoughnut;
